import { gql } from '@apollo/client';

export const fetchPendingInvoicesForTransactionAccount = gql`
  query fetchPendingInvoicesForTransactionAccount($id: ID!) {
    transactionAccount(id: $id) {
      id
      pendingInvoices
    }
  }
`;
